// Copyright (c) 2015, mobileX Neo
// MIT License. See license.txt

window.cstr = function(s) {
	if(s==null)return '';
	return s+'';
};

window.cint = function(v, def) {
	if (v === true)
		return 1;
	if (v === false)
		return 0;
	v = v + '';
	if (v !== "0") v = lstrip(v, ['0']);
	v = parseInt(v); // eslint-ignore-line
	if (isNaN(v)) v = def === undefined ? 0 : def;
	return v;
};

// to title case
window.toTitle = function(str){
	var word_in = str.split(" ");
	var word_out = [];

	for(var w in word_in){
		word_out[w] = word_in[w].charAt(0).toUpperCase() + word_in[w].slice(1);
	}

	return word_out.join(" ");
};

window.is_null = function(v) {
	if(v===null || v===undefined || cstr(v).trim()==="") return true;
};

window.copy_dict = function(d) {
	var n = {};
	for(var k in d) n[k] = d[k];
	return n;
};

window.validate_email = function(txt) {
	return neo.utils.validate_type(txt, "email");
};

window.validate_phone = function(txt) {
	return neo.utils.validate_type(txt, "phone");
};

window.validate_name = function(txt) {
	return neo.utils.validate_type(txt, "name");
};

window.validate_url = function(txt) {
	return neo.utils.validate_type(txt, "url");
};

window.validate_field_cnpj = function(txt) {
	return neo.utils.validate_type(txt, "cnpj");
}

window.validate_field_cpf = function(txt) {
	return neo.utils.validate_type(txt, "cpf");
}

window.validate_field_cep = function(txt) {
	return neo.utils.validate_type(txt, "cep");
}

window.setup_field_cnpj = function(frm, fieldname) {
	frm.fields_dict[fieldname].$input.on('input', function () {
		let inputVal = $(this).val();
		let numericVal = inputVal.replace(/\D/g, '');
		let formatted = numericVal;
		if (numericVal.length > 12) {
			formatted = numericVal.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{1,2}).*/, "$1.$2.$3/$4-$5");
		} else if (numericVal.length > 8) {
			formatted = numericVal.replace(/^(\d{2})(\d{3})(\d{3})(\d{1,4}).*/, "$1.$2.$3/$4");
		} else if (numericVal.length > 5) {
			formatted = numericVal.replace(/^(\d{2})(\d{3})(\d{1,3}).*/, "$1.$2.$3");
		} else if (numericVal.length > 2) {
			formatted = numericVal.replace(/^(\d{2})(\d{1,3}).*/, "$1.$2");
		}
		if (inputVal !== formatted) {
			$(this).val(formatted);
		}
	});
}

window.setup_field_cpf = function(frm, fieldname) {
	frm.fields_dict[fieldname].$input.on('input', function () {
		let inputVal = $(this).val();
		let numericVal = inputVal.replace(/\D/g, '');
		let formatted = numericVal;

		if (numericVal.length > 9) {
			formatted = numericVal.replace(/^(\d{3})(\d{3})(\d{3})(\d{1,2}).*/, "$1.$2.$3-$4");
		} else if (numericVal.length > 6) {
			formatted = numericVal.replace(/^(\d{3})(\d{3})(\d{1,3}).*/, "$1.$2.$3");
		} else if (numericVal.length > 3) {
			formatted = numericVal.replace(/^(\d{3})(\d{1,3}).*/, "$1.$2");
		}

		if (inputVal !== formatted) {
			$(this).val(formatted);
		}
	});
}

window.setup_field_cep = function (frm, fieldname) {
    frm.fields_dict[fieldname].$input.off('input').on('input', function () {
        let inputVal = $(this).val();
        let numericVal = inputVal.replace(/\D/g, '');
        let formatted = numericVal;

        if (numericVal.length > 5) {
            formatted = numericVal.replace(/^(\d{5})(\d{1,3}).*/, "$1-$2");
        }

        if (inputVal !== formatted) {
            $(this).val(formatted);
        }
    });
}

window.setup_field_phone = function (frm, fieldname) {
    frm.fields_dict[fieldname].$input.off('input').on('input', function () {
        let inputVal = $(this).val();
        let numericVal = inputVal.replace(/\D/g, '');
        let formatted = numericVal;

        if (numericVal.length > 10) {
            formatted = numericVal.replace(/^(\d{2})(\d{5})(\d{4}).*/, "($1) $2-$3");
        } else if (numericVal.length > 6) {
            formatted = numericVal.replace(/^(\d{2})(\d{4})(\d{0,4}).*/, "($1) $2-$3");
        } else if (numericVal.length > 2) {
            formatted = numericVal.replace(/^(\d{2})(\d{0,5}).*/, "($1) $2");
        }

        if (inputVal !== formatted) {
            $(this).val(formatted);
        }
    });
}

window.nth = function(number) {
	number = cint(number);
	var s = 'th';
	if((number+'').substr(-1)=='1') s = 'st';
	if((number+'').substr(-1)=='2') s = 'nd';
	if((number+'').substr(-1)=='3') s = 'rd';
	return number+s;
};

window.has_words = function(list, item) {
	if(!item) return true;
	if(!list) return false;
	for(var i=0, j=list.length; i<j; i++) {
		if(item.indexOf(list[i])!=-1)
			return true;
	}
	return false;
};

window.has_common = function(list1, list2) {
	if(!list1 || !list2) return false;
	for(var i=0, j=list1.length; i<j; i++) {
		if(in_list(list2, list1[i]))return true;
	}
	return false;
};
